import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';

const About = () => {
  const { language } = useLanguage();
  const t = translations[language];
  return (
    <section id="about" className="py-24 bg-gradient-to-b from-gray-900 via-slate-800 to-gray-900 relative overflow-hidden text-white">
      {/* Security Grid Background */}
      <div className="absolute inset-0 security-grid opacity-10"></div>
      
      {/* Corner Brackets */}
      <div className="absolute top-8 left-8 w-16 h-16 border-t-2 border-l-2 border-green-500/50"></div>
      <div className="absolute top-8 right-8 w-16 h-16 border-t-2 border-r-2 border-green-500/50"></div>
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-5xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <div className="inline-block px-6 py-2 bg-black/60 border-2 border-green-500/50 rounded mb-6">
              <span className="text-green-400 font-semibold font-mono text-sm tracking-wider">{t.aboutBadge}</span>
            </div>
            <h2 className="text-5xl md:text-6xl font-extrabold mb-6 font-mono">
              <span className="text-gray-300">{t.aboutTitle}</span>{' '}
              <span className="bg-gradient-to-r from-green-400 to-cyan-400 bg-clip-text text-transparent">{t.aboutTitle2}</span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-green-500 to-cyan-500 mx-auto rounded-full"></div>
          </div>

          {/* Content Cards */}
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <div className="bg-gray-800/80 backdrop-blur-sm rounded-lg p-8 shadow-2xl border-2 border-green-500/30 transform hover:scale-105 hover:border-green-500/60 transition-all duration-300">
              <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-cyan-500 rounded-lg flex items-center justify-center mb-6 shadow-lg shadow-green-500/50">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4 font-mono">{t.aboutCard1Title}</h3>
              <p className="text-gray-300 leading-relaxed">
                {t.aboutCard1Text}
              </p>
            </div>

            <div className="bg-gray-800/80 backdrop-blur-sm rounded-lg p-8 shadow-2xl border-2 border-cyan-500/30 transform hover:scale-105 hover:border-cyan-500/60 transition-all duration-300">
              <div className="w-16 h-16 bg-gradient-to-br from-cyan-500 to-green-500 rounded-lg flex items-center justify-center mb-6 shadow-lg shadow-cyan-500/50">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4 font-mono">{t.aboutCard2Title}</h3>
              <p className="text-gray-300 leading-relaxed">
                {t.aboutCard2Text}
              </p>
            </div>
          </div>

          {/* Bottom Section */}
          <div className="bg-gradient-to-r from-gray-800 via-gray-900 to-gray-800 rounded-lg p-8 md:p-12 border-2 border-green-500/30 shadow-2xl">
            <div className="max-w-3xl mx-auto text-center">
              <div className="flex items-center justify-center mb-6">
                <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse-glow mr-3"></div>
                <h3 className="text-3xl md:text-4xl font-bold font-mono">{t.aboutBottomTitle}</h3>
                <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse-glow ml-3"></div>
              </div>
              <p className="text-lg text-gray-300 leading-relaxed">
                {t.aboutBottomText}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;

